import { Feature } from "ol";
import { useEffect, useState } from "react";
import {
  FEATURE_STATE,
  FEATURE_STATE_CONVERT,
  FeatureState,
} from "../types/inspect.type";
import { FEATURE_CHANGES_PROPERTIES } from "./useFeatureStateSync";

export const useFilteredFeatures = () => {
  const [features, setFeatures] = useState<Feature[]>([]);
  const [filteredFeatures, setFilteredFeatures] = useState<Feature[]>([]);
  const [selectedState, setSelectedState] = useState<FeatureState>("TOTAL");
  const [confirmedFeatureCount, setConfirmedFeatureCount] = useState(0);
  const [incorrectFeatureCount, setIncorrectFeatureCount] = useState(0);
  const [uncertainFeatureCount, setUncertainFeatureCount] = useState(0);
  const [pendingFeatureCount, setPendingFeatureCount] = useState(0);
  const [notDetectionFeatureCount, setNotDetectionFeatureCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isReload, setReload] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  useEffect(() => {
    if (selectedState === FEATURE_STATE.TOTAL) {
      setFilteredFeatures(features);
    } else {
      const filteredFeature = features.filter((f) => {
        const stateKey = f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY);

        if (
          FEATURE_STATE_CONVERT[selectedState] === FEATURE_STATE_CONVERT.PENDING
        ) {
          return (
            f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "CORRECT" &&
            f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "INCORRECT" &&
            f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "UNCERTAIN" &&
            f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "NOT_DETECTED"
          );
        }

        return stateKey === FEATURE_STATE_CONVERT[selectedState];
      });
      setFilteredFeatures(filteredFeature);
    }
  }, [selectedState, features]);

  useEffect(() => {
    setConfirmedFeatureCount(
      features.filter(
        (f) => f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) === "CORRECT"
        // && f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
      ).length
    );
    setIncorrectFeatureCount(
      features.filter(
        (f) => f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) === "INCORRECT"
        // && f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
      ).length
    );
    setUncertainFeatureCount(
      features.filter(
        (f) => f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) === "UNCERTAIN"
        // && f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
      ).length
    );
    setNotDetectionFeatureCount(
      features.filter(
        (f) => f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) === "NOT_DETECTED"
        // && f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
      ).length
    );
    setPendingFeatureCount(
      features.filter(
        (f) =>
          f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "CORRECT" &&
          f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "INCORRECT" &&
          f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "UNCERTAIN" &&
          f.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY) !== "NOT_DETECTED"
        // && f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
      ).length
    );
    // setTotalCount(features.filter(
    //   (f) => f.get(FEATURE_CHANGES_PROPERTIES.CONFIRMED.KEY) === "0"
    // ).length);

    setTotalCount(features.length);
  }, [features, isReload]);

  const handleAddFeature = (feature: Feature) => {
    setFeatures([...features, feature]);
  };

  const handleDeleteFeature = (id: string) => {
    setFeatures(features.filter((feature) => feature.get("id") !== id));
  };

  useEffect(() => {
    handleDeleteFeature(deleteId);
  }, [deleteId]);

  return {
    features,
    filteredFeatures,
    selectedState,
    confirmedFeatureCount,
    incorrectFeatureCount,
    uncertainFeatureCount,
    pendingFeatureCount,
    notDetectionFeatureCount,
    totalCount,
    setFeatures,
    setSelectedState,
    setReload,
    handleAddFeature,
    setDeleteId,
  };
};
